import React from 'react';
import {
  Modal,
  Input,
  Button,
  Select,
  Icon,
  Col,
  Row,
  Tooltip,
  Upload,
  Spin
} from 'antd';
import MultipleSelect from './multipleSelect.js';
import moment from 'moment';
import { equals } from 'ramda';
import DisabledPopup from './disabledPopup.js';
const { TextArea } = Input;
const Option = Select.Option;

class Investigation extends React.Component {
  state = {
    why: '',
    projectTitle: '',
    learnerProfile: [],
    serviceLearning: [],
    need: [],
    editingSelection: false,
    type: [],
    categories: [],
    impact: '',
    notes: '',
    disabledPopup: false,
    uploading: false
  };

  componentDidMount = () => {
    const { data, title } = this.props;
    if (data) {
      this.setState({
        why: data.identifyAndNeed,
        projectTitle: title,
        notes: data.notes,
        need: data.need || [],
        serviceLearning: data.relevantServiceLearningOutcomes || [],
        type: data.projectType,
        learnerProfile: data.learnerProfileAttribute || [],
        impact: data.desiredImpact,
        categories: data.ATLCategories || []
      });
    }
  };

  componentWillUnmount = () => {
    this.saveData();
  };

  confirmMultiple = selection => {
    const editing = this.state.editingSelection;
    this.setState({ [editing]: selection, editingSelection: false }, () =>
      this.saveData()
    );
  };

  cancelField = (field, category) => {
    let fields = this.state[category];
    fields = fields.filter(item => item !== field);
    this.setState({ [category]: fields }, () => this.saveData());
  };

  uploadFile = file => {
    const { firebase, uid, editingId } = this.props;
    this.setState({ uploading: true });
    let evidence = (this.props.data && this.props.data.evidence) || [];
    firebase
      .uploadFile(`/projects/${uid}/${editingId}`, file.file)
      .then(snapshot => {
        evidence.push({
          url: snapshot.uploadTaskSnaphot.metadata.downloadURLs[0],
          name: file.file.name
        });
        firebase
          .database()
          .ref(`/projects/${uid}/${editingId}/Investigation/evidence/`)
          .set(evidence);
        this.setState({ uploading: false });
      });
  };

  saveData = toNextPhase => {
    let data = {
      Investigation: {
        completedDate: moment().unix(),
        is_complete: true,
        desiredImpact: this.state.impact,
        learnerProfileAttribute: this.state.learnerProfile,
        projectType: this.state.type,
        relevantServiceLearningOutcomes: this.state.serviceLearning,
        identifyAndNeed: this.state.why,
        notes: this.state.notes,
        need: this.state.need,
        evidence: this.props.data.evidence,
        ATLCategories: this.state.categories
      },
      projectTitle: this.state.projectTitle
    };
    if (toNextPhase) {
      data.current_phase = 'Preparation';
    }
    this.props.saveData(data);
  };

  isDisabled = () => {
    const {
      why,
      what,
      learnerProfile,
      serviceLearning,
      type,
      categories,
      impact,
      need
    } = this.state;
    if (
      why == '' ||
      what == '' ||
      learnerProfile.length == 0 ||
      serviceLearning.length == 0 ||
      type.length == 0 ||
      categories.length == 0 ||
      impact == ''
      //this.props.currentPhase !== 1
    ) {
      return true;
    } else {
      return false;
    }
  };

  deleteFile = url => {
    const { firebase, uid, editingId } = this.props;
    const path = firebase.storage().refFromURL(url).location.path;
    firebase.deleteFile(path);
    let evidence = this.props.data && this.props.data.evidence;
    evidence = evidence && evidence.filter(item => item.url !== url);
    firebase
      .database()
      .ref(`/projects/${uid}/${editingId}/Investigation/evidence`)
      .set(evidence);
  };

  render() {
    const { color, t, projectCompleted } = this.props;
    const { uploading } = this.state;
    const loadingIcon = (
      <Icon
        type="loading"
        style={{ fontSize: 24, marginLeft: 10, color }}
        spin
      />
    );

    const styles = {
      titleDiv: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginTop: 20
      },
      title: {
        marginBottom: 0,
        fontSize: 16,
        fontFamily: 'Arial Rounded MT Bold',
        color: color,
        alignSelf: 'left'
      },
      addMultiple: {
        backgroundColor: 'white',
        borderRadius: 20,
        height: 45,
        marginTop: 10,
        position: 'relative',
        border: `1px solid ${color}`,
        cursor: 'pointer'
      },
      nextBtn: {
        fontSize: 16,
        backgroundColor: this.props.color,
        width: '100%',
        position: 'fixed',
        bottom: 0,
        textAlign: 'center',
        color: 'white',
        padding: 10,
        cursor: 'pointer'
      },
      disabledNextBtn: {
        fontSize: 16,
        backgroundColor: '#d0d0d0',
        width: '100%',
        position: 'fixed',
        bottom: 0,
        textAlign: 'center',
        color: 'white',
        padding: 10,
        cursor: 'not-allowed'
      },
      uploadBtn: {
        fontSize: 20,
        fontFamily: 'Times new roman',
        color: 'white',
        backgroundColor: color,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 30,
        width: 30,
        borderRadius: '50%',
        cursor: 'pointer',
        marginTop: 10,
        boxShadow: '0 2px 3px 0 rgba(0,0,0,0.5)'
      }
    };

    return (
      <div style={{ position: 'absolute', width: '100%', top: 260 }}>
        <div style={{ maxWidth: 650, margin: '0 auto', paddingBottom: 70 }}>
          <div style={styles.titleDiv}>
            <h3 style={styles.title}>{t('Why? Identify & State Need')}</h3>
            <Tooltip title="What problem have you identified that you can solve through your service learning project?">
              <img style={{ height: 16, width: 16 }} src={this.props.icon} />
            </Tooltip>
          </div>
          <TextArea
            onBlur={() => this.saveData()}
            rows={4}
            disabled={projectCompleted}
            onChange={e => this.setState({ why: e.target.value })}
            style={{
              marginTop: 10,
              border: `1px solid ${color}`,
              fontSize: 16
            }}
            value={this.state.why}
          />
          <div style={styles.titleDiv}>
            <h3 style={styles.title}>
              {t(
                'How do you know that this need really exists? What research did you carry out to authenticate the need?'
              )}
            </h3>
          </div>

          <div
            onClick={() =>
              !projectCompleted &&
              this.setState({
                editingSelection: 'need',
                mode: 'multiple'
              })
            }
            style={
              projectCompleted
                ? Object.assign(styles.addMultiple, {
                    backgroundColor: '#d0d0d0'
                  })
                : styles.addMultiple
            }>
            <Icon
              style={{
                color: color,
                position: 'absolute',
                right: 15,
                top: 10,
                fontSize: 21
              }}
              type="plus"
            />
          </div>
          <Row style={{ marginLeft: -10, marginRight: -10 }}>
            {this.state.need &&
              this.state.need.map(item => (
                <Col xs={8} style={{ padding: 10 }}>
                  <div
                    style={{
                      borderRadius: 10,
                      backgroundColor: color,
                      fontSize: 14,
                      color: 'white',
                      padding: 10,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between'
                    }}>
                    <span>{t(item)}</span>
                    {!projectCompleted && (
                      <span
                        onClick={() => this.cancelField(item, 'need')}
                        style={{
                          float: 'right',
                          width: 20,
                          textAlign: 'right',
                          cursor: 'pointer'
                        }}>
                        X
                      </span>
                    )}
                  </div>
                </Col>
              ))}
          </Row>

          <div style={styles.titleDiv}>
            <div style={{ display: 'flex' }}>
              <h3 style={styles.title}>{t('Upload your research evidence')}</h3>
              {uploading && <Spin indicator={loadingIcon} />}
            </div>
            {!projectCompleted && (
              <Upload customRequest={this.uploadFile} showUploadList={false}>
                <div style={styles.uploadBtn}>+</div>
              </Upload>
            )}
          </div>

          <Row style={{ width: '100%', marginBottom: 40 }}>
            {this.props.data.evidence &&
              this.props.data.evidence.length > 0 &&
              this.props.data.evidence.map(item => (
                <Col xs={24} style={{ padding: 0, marginTop: 10 }}>
                  <div
                    style={{
                      borderRadius: 10,
                      backgroundColor: color,
                      fontSize: 14,
                      color: 'white',
                      padding: 10,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between'
                    }}>
                    <a href={item.url} target="_blank">
                      <span>{item.name}</span>
                    </a>
                    {!projectCompleted && (
                      <span
                        onClick={() => this.deleteFile(item.url)}
                        style={{
                          float: 'right',
                          width: 20,
                          textAlign: 'right',
                          cursor: 'pointer'
                        }}>
                        X
                      </span>
                    )}
                  </div>
                </Col>
              ))}
          </Row>

          <div style={styles.titleDiv}>
            <h3 style={styles.title}>{t('What? (Title of Project)')}</h3>
          </div>
          <Input
            onBlur={() => this.saveData()}
            disabled={projectCompleted}
            onChange={e => this.setState({ projectTitle: e.target.value })}
            style={{
              marginTop: 10,
              border: `1px solid ${color}`,
              fontSize: 16,
              height: 45
            }}
            value={this.state.projectTitle}
          />
          <div style={styles.titleDiv}>
            <h3 style={styles.title}>{t('Learner attributes')}</h3>
            <Tooltip title="What Learner attributes do you think you'll develop the most as a result of your experiences? You can choose as many as you like.">
              <img style={{ height: 16, width: 16 }} src={this.props.icon} />
            </Tooltip>
          </div>
          <div
            onClick={() =>
              !projectCompleted &&
              this.setState({
                editingSelection: 'learnerProfile',
                mode: 'multiple'
              })
            }
            style={
              projectCompleted
                ? Object.assign(styles.addMultiple, {
                    backgroundColor: '#d0d0d0'
                  })
                : styles.addMultiple
            }>
            <Icon
              style={{
                color: color,
                position: 'absolute',
                right: 15,
                top: 10,
                fontSize: 21
              }}
              type="plus"
            />
          </div>
          <Row style={{ marginLeft: -10, marginRight: -10 }}>
            {this.state.learnerProfile &&
              this.state.learnerProfile.map(item => (
                <Col xs={8} style={{ padding: 10 }}>
                  <div
                    style={{
                      borderRadius: 10,
                      backgroundColor: color,
                      fontSize: 14,
                      color: 'white',
                      padding: 10,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between'
                    }}>
                    <span>{t(item)}</span>
                    {!projectCompleted && (
                      <span
                        onClick={() => this.cancelField(item, 'learnerProfile')}
                        style={{
                          float: 'right',
                          width: 20,
                          textAlign: 'right',
                          cursor: 'pointer'
                        }}>
                        X
                      </span>
                    )}
                  </div>
                </Col>
              ))}
          </Row>
          <div style={styles.titleDiv}>
            <h3 style={styles.title}>
              {t('Relevant Service Learning Outcomes')}
            </h3>
            <Tooltip title="As a result of this project, which service learning outcomes do you think you are most likely to achieve?">
              <img style={{ height: 16, width: 16 }} src={this.props.icon} />
            </Tooltip>
          </div>
          <div
            onClick={() =>
              !projectCompleted &&
              this.setState({
                editingSelection: 'serviceLearning',
                mode: 'multiple'
              })
            }
            style={styles.addMultiple}>
            <Icon
              style={{
                color: color,
                position: 'absolute',
                right: 15,
                top: 10,
                fontSize: 21
              }}
              type="plus"
            />
          </div>
          <Row style={{ marginLeft: -10, marginRight: -10 }}>
            {this.state.serviceLearning &&
              this.state.serviceLearning.map(item => (
                <Col xs={24} style={{ padding: 10 }}>
                  <div
                    style={{
                      borderRadius: 10,
                      backgroundColor: color,
                      fontSize: 14,
                      color: 'white',
                      padding: 10,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between'
                    }}>
                    <span>{t(item)}</span>
                    {!projectCompleted && (
                      <span
                        onClick={() =>
                          this.cancelField(item, 'serviceLearning')
                        }
                        style={{
                          float: 'right',
                          width: 20,
                          textAlign: 'right',
                          cursor: 'pointer'
                        }}>
                        X
                      </span>
                    )}
                  </div>
                </Col>
              ))}
          </Row>
          <div style={styles.titleDiv}>
            <h3 style={styles.title}>{t('Type of Project')}</h3>
            <Tooltip
              title={
                <div>
                  Direct Service: You interact with people, the environment or
                  animals in your service
                  <div style={{ marginTop: 5 }} />
                  <br />
                  Indirect Service: You do not see the people or organistions
                  that benefit from your service{' '}
                  <div style={{ marginTop: 5 }} />
                  <br />
                  Research: You use information to report on a topic to
                  influence someone or something{' '}
                  <div style={{ marginTop: 5 }} />
                  <br />
                  Advocacy: You speak for a cause or concern in order to promote
                  action
                  <div style={{ marginTop: 5 }} />
                  <br />
                  Your project might fit more than one type. Choose the type
                  which is the main focus of your project.
                </div>
              }>
              <img style={{ height: 16, width: 16 }} src={this.props.icon} />
            </Tooltip>
          </div>
          <div
            onClick={() =>
              !projectCompleted &&
              this.setState({ editingSelection: 'type', mode: 'single' })
            }
            style={styles.addMultiple}>
            <h3 style={styles.title}>
              {this.state.type &&
                this.state.type.length !== 0 &&
                t(this.state.type[0])}
            </h3>
            <Icon
              style={{
                color: color,
                position: 'absolute',
                right: 15,
                top: 10,
                fontSize: 21
              }}
              type="right"
            />
          </div>

          <div style={styles.titleDiv}>
            <h3 style={styles.title}>{t('Skills')}</h3>
          </div>
          <div
            onClick={() =>
              !projectCompleted &&
              this.setState({
                editingSelection: 'categories',
                mode: 'multiple'
              })
            }
            style={styles.addMultiple}>
            <Icon
              style={{
                color: color,
                position: 'absolute',
                right: 15,
                top: 10,
                fontSize: 21
              }}
              type="plus"
            />
          </div>
          <Row style={{ marginLeft: -10, marginRight: -10 }}>
            {this.state.categories &&
              this.state.categories.map(item => (
                <Col xs={8} style={{ padding: 10 }}>
                  <div
                    style={{
                      borderRadius: 10,
                      backgroundColor: color,
                      fontSize: 14,
                      color: 'white',
                      padding: 10,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between'
                    }}>
                    <span>{t(item)}</span>
                    {!projectCompleted && (
                      <span
                        onClick={() => this.cancelField(item, 'categories')}
                        style={{
                          float: 'right',
                          width: 20,
                          textAlign: 'right',
                          cursor: 'pointer'
                        }}>
                        X
                      </span>
                    )}
                  </div>
                </Col>
              ))}
          </Row>

          <div style={styles.titleDiv}>
            <h3 style={styles.title}>{t('Desired Impact')}</h3>
            <Tooltip title="What do you hope will be the impact of your project once you've completed it? This can be a change within you as well as impact on other people, places or organizations.">
              <img style={{ height: 16, width: 16 }} src={this.props.icon} />
            </Tooltip>
          </div>
          <TextArea
            onBlur={() => this.saveData()}
            disabled={projectCompleted}
            rows={4}
            onChange={e => this.setState({ impact: e.target.value })}
            style={{
              marginTop: 10,
              border: `1px solid ${color}`,
              fontSize: 16
            }}
            value={this.state.impact}
          />
          <div style={styles.titleDiv}>
            <h3
              style={Object.assign(styles.title, {
                marginTop: 8,
                marginLeft: 10
              })}>
              {t('Notes')}
            </h3>
          </div>
          <TextArea
            onBlur={() => this.saveData()}
            disabled={projectCompleted}
            rows={4}
            onChange={e => this.setState({ notes: e.target.value })}
            style={{
              marginTop: 10,
              border: `1px solid ${color}`,
              fontSize: 16
            }}
            value={this.state.notes}
          />
        </div>

        <MultipleSelect
          t={t}
          selected={this.state[this.state.editingSelection]}
          color={this.props.color}
          field={this.state.editingSelection}
          close={() => this.setState({ editingSelection: false })}
          open={this.state.editingSelection !== false}
          confirm={this.confirmMultiple}
          mode={this.state.mode}
        />
        {!projectCompleted && (
          <DisabledPopup
            open={this.state.disabledPopup}
            close={() => this.setState({ disabledPopup: false })}
            color={color}
          />
        )}
        <div
          onClick={() =>
            !this.isDisabled() && !projectCompleted
              ? this.saveData(true)
              : !projectCompleted && this.setState({ disabledPopup: true })
          }
          style={
            this.isDisabled() || projectCompleted
              ? styles.disabledNextBtn
              : styles.nextBtn
          }>
          {t('Next Phase')}
        </div>
      </div>
    );
  }
}

export default Investigation;



// WEBPACK FOOTER //
// ./src/containers/StudentApp/components/investigation.js